/**
 * Asynchronously loads the component for HomePage
 */

 import { lazyLoad } from 'utils/loadable';

 export const SoftWarePage = lazyLoad(
   () => import('./index'),
   module => module.SoftWarePage,
 );
 